/**
 * What data is available when a filter runs. Question conditions run before
 * there is a pro, so they can't check skills; routing filters can.
 */
export type FilterScope = 'Provider' | 'Submitted'

/**
 * The scopes, by name.
 */
export const FilterScopes = {
  PROVIDER: 'Provider',
  SUBMITTED: 'Submitted',
  ALL: ['Provider', 'Submitted'],
} as const satisfies {
  PROVIDER: FilterScope
  SUBMITTED: FilterScope
  ALL: readonly FilterScope[]
}
